import LoginPage from './login.vue';
import LoginPageOpenID from './login-openid.vue';

const routes = [
    {
        path: '/login',
        name: 'login',
        id: 'login',
        component: LoginPage,
        meta: { hideNavbar: true },
        omitFromNav: true,
    },
    // Allow specific navigation to each login page, while /login will use the component of the configured default
    {
        path: '/auth-openid/login',
        name: 'auth-openid/login',
        id: 'auth-openid/login',
        component: LoginPageOpenID,
        meta: { hideNavbar: true },
        omitFromNav: true,
    },
];

export default routes;
